var map = {
	"./ion-accordion_2.entry.js": [
		32513,
		72076,
		32513
	],
	"./ion-action-sheet.entry.js": [
		31532,
		72076,
		31532
	],
	"./ion-alert.entry.js": [
		68532,
		72076,
		68532
	],
	"./ion-app_8.entry.js": [
		34790,
		72076,
		34790
	],
	"./ion-avatar_3.entry.js": [
		60047,
		60047
	],
	"./ion-back-button.entry.js": [
		60420,
		72076,
		60420
	],
	"./ion-backdrop.entry.js": [
		16546,
		16546
	],
	"./ion-breadcrumb_2.entry.js": [
		82924,
		72076,
		82924
	],
	"./ion-button_2.entry.js": [
		2489,
		2489
	],
	"./ion-card_5.entry.js": [
		66666,
		66666
	],
	"./ion-checkbox.entry.js": [
		56713,
		72076,
		56713
	],
	"./ion-chip.entry.js": [
		69994,
		69994
	],
	"./ion-col_3.entry.js": [
		67054,
		67054
	],
	"./ion-datetime-button.entry.js": [
		11522,
		34607,
		11522
	],
	"./ion-datetime_3.entry.js": [
		93515,
		34607,
		72076,
		93515
	],
	"./ion-fab_3.entry.js": [
		37921,
		72076,
		37921
	],
	"./ion-img.entry.js": [
		57018,
		34637
	],
	"./ion-infinite-scroll_2.entry.js": [
		70617,
		72076,
		70617
	],
	"./ion-input.entry.js": [
		50734,
		72076,
		50734
	],
	"./ion-item-option_3.entry.js": [
		46235,
		72076,
		46235
	],
	"./ion-item_8.entry.js": [
		87028,
		72076,
		87028
	],
	"./ion-loading.entry.js": [
		35362,
		72076,
		35362
	],
	"./ion-menu_3.entry.js": [
		64813,
		72076,
		64813
	],
	"./ion-modal.entry.js": [
		39527,
		72076,
		39527
	],
	"./ion-nav_2.entry.js": [
		62586,
		62586
	],
	"./ion-picker-column-internal.entry.js": [
		93475,
		72076,
		93475
	],
	"./ion-picker-internal.entry.js": [
		47182,
		47182
	],
	"./ion-popover.entry.js": [
		88763,
		72076,
		88763
	],
	"./ion-progress-bar.entry.js": [
		96135,
		96135
	],
	"./ion-radio_2.entry.js": [
		7860,
		72076,
		7860
	],
	"./ion-range.entry.js": [
		50051,
		72076,
		50051
	],
	"./ion-refresher_2.entry.js": [
		48451,
		72076,
		48451
	],
	"./ion-reorder_2.entry.js": [
		53528,
		72076,
		53528
	],
	"./ion-ripple-effect.entry.js": [
		42598,
		42598
	],
	"./ion-route_4.entry.js": [
		48696,
		48696
	],
	"./ion-searchbar.entry.js": [
		19615,
		72076,
		19615
	],
	"./ion-segment_2.entry.js": [
		76670,
		72076,
		76670
	],
	"./ion-select_3.entry.js": [
		13178,
		72076,
		13178
	],
	"./ion-spinner.entry.js": [
		69919,
		72076,
		69919
	],
	"./ion-split-pane.entry.js": [
		99789,
		99789
	],
	"./ion-tab-bar_2.entry.js": [
		39644,
		72076,
		39644
	],
	"./ion-tab_2.entry.js": [
		15404,
		15404
	],
	"./ion-text.entry.js": [
		46183,
		46183
	],
	"./ion-textarea.entry.js": [
		54766,
		72076,
		54766
	],
	"./ion-toast.entry.js": [
		89265,
		72076,
		89265
	],
	"./ion-toggle.entry.js": [
		7224,
		72076,
		7224
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 48067;
module.exports = webpackAsyncContext;